<style scoped>
    .container{
        background: #444;
        min-height: 300px;
        height: 100%;
        padding: 20px;
    }
    .candid-photo img{
        width: 100%;
    }
    .vue-image-crop-upload{
        z-index: 500;
    }
</style>
<template>
  <div class="container">
    <div
      class="line"
      style="margin-left: 8px"
    >
      <Select
        v-model="params.parent_team_id"
        placeholder="选择团队"
        style="width: 200px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有团队
        </Option>
        <Option
          v-for="team in teams"
          :key="team.id"
          :value="team.id"
        >
          {{ team.name }}
        </Option>
      </Select>
      <i-input
        v-model="params.search"
        style="width: 200px"
        placeholder="请输入搜索关键字"
        @on-enter="doSearch"
      />
      <Button
        type="primary"
        :loading="loading"
        @click="doSearch"
      >
        搜索
      </Button>
    </div>
    <div class="line">
      <div
        v-for="customer in customers"
        :key="customer.id"
      >
        <Row
          type="flex"
          justify="center"
          align="middle"
        >
          <i-col span="20">
            <IntroCard :customer="customer" />
          </i-col>
          <i-col span="4">
            <ButtonGroup>
              <Button @click="editCustomer(customer)">
                简介/标签
              </Button>
              <Button @click="editCustomerAvatar(customer)">
                头像
              </Button>
            </ButtonGroup>
          </i-col>
        </Row>
      </div>
    </div>
    <Spin
      v-show="loading"
      fix
    />
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <Modal
      v-model="edit_config.modal"
      :loading="edit_config.loading"
      title="编辑"
      @on-ok="editOk"
    >
      <div class="line">
        <i-input
          v-model="edit_customer.intro"
          type="textarea"
          :autosize="{ minRows: 3 }"
          :maxlength="500"
          placeholder="个人简介..."
        />
      </div>
      <!--<div-->
      <!--  v-if="edit_customer.customer_tag"-->
      <!--  class="line"-->
      <!--&gt;-->
      <!--  <i-input-->
      <!--    v-model="edit_customer.customer_tag.tag_name"-->
      <!--    placeholder="标签"-->
      <!--  >-->
      <!--    <span slot="prepend">标签</span>-->
      <!--  </i-input>-->
      <!--</div>-->
    </Modal>
    <AvatarUpload
      v-if="show_avatar_uploader"
      v-model="show_avatar_uploader"
      field="file"
      :params="avatar_params"
      :width="300"
      :height="300"
      :url="upload_candid_photo_url"
      :no-rotate="false"
      with-credentials
      img-format="jpg"
      @src-file-set="cropFileSet"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
    />
  </div>
</template>
<script route="/hr/schoolmate">
  import AvatarUpload from 'vue-image-crop-upload';
  import FileUploader from '../components/file/uploader';
  import IntroCard from '../components/customer/intro_card';
  import { hrUrl } from '@/libs/util.js'
  export default {
    components: { AvatarUpload, IntroCard, FileUploader },
    data() {
      return {
        upload_to_oss_public: this.$util.api.upload_to_oss_public,
        // upload_candid_photo_url: Util.api.upload_candid_photo,
        upload_candid_photo_url: `${hrUrl}/hr/culture/upload_customer_candid_photo`,
        params: {
          parent_team_id: 0,
          search: '',
          page: 1,
          per_page: 20
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        teams: [],
        customers: [],
        loading: false,
        edit_customer: {},
        edit_config: {
          modal: false,
          loading: true
        },
        show_avatar_uploader: false
      }
    },
    computed: {
      avatar_params() {
        return {
          customer_id: this.edit_customer.id
        }
      }
    },
    created() {
      this.getParentTeams();
      this.doSearch();
    },
    mounted() {
      //
    },
    methods: {
      editCustomer(customer) {
        this.edit_customer = this.$util.clone(customer);
        this.edit_config.modal = true;
      },
      editCustomerAvatar(customer) {
        this.edit_customer = customer;
        this.show_avatar_uploader = true;
      },
      getParentTeams() {
        this.getting_teams = true;
        this.$util.ajax.get(this.$util.api.parent_teams).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.teams = res.data.teams;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.getting_teams = false;
        });
      },
      pageChange(page) {
        this.params.page = page;
        this.getCustomers();
      },
      doSearch() {
        this.params.page = 1;
        this.getCustomers();
      },
      getCustomers() {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.query_schoolmate, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.customers = data.customers;
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      editOk() {
        this.$util.ajax.post(`${hrUrl}/hr/culture/edit_customer_intro`, {
          customer_id: this.edit_customer.id,
          intro: this.edit_customer.intro,
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 0) {
            this.$util.insertOrUpdateArrayItem(this.customers, this.edit_customer);
            this.edit_config.modal = false;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.resetEditLoading();
        });
      },
      resetEditLoading() {
        this.edit_config.loading = false;
        setTimeout(() => {
          this.edit_config.loading = true;
        }, 500);
      },
      cropFileSet(filename, filetype, filesize) {
        const extname = this.$util.extname(filename).toLowerCase();
        const formats = ['.jpg', '.jpeg', '.png'];
        if (!formats.includes(extname)) {
          this.$Message.warning({
            content: `不支持该图片格式(${extname}), <p>请上传 ${formats.join('/')} 格式图片 </p>`,
            duration: 4
          })
        }
        console.log(filename, extname, filetype, filesize);
      },
      cropSuccess() {
        //
      },
      cropUploadSuccess(res, field) {
        console.log(res);
        if (res.code === 0) {
          this.edit_customer.candid_photo = res.data;
          this.$util.insertOrUpdateArrayItem(this.customers, this.edit_customer);
          this.show_avatar_uploader = false;
        } else {
          this.$Modal.error({title: '提示', content: res.msg});
        }
      },
      cropUploadFail() {
        this.$Modal.error({title: '提示', content: '上传失败, 请重试!'});
      },
      uploadFile(res) {
        this.edit_customer.candid_photo = res.file;
      },
      imageUrl(filepath) {
        return this.$util.publicOSSUrl(filepath) + '?x-oss-process=style/avatar';
      }
    }
  }
</script>
